import React from 'react';
import { NextPage } from 'next';
import Layout from '../../components/layout';
import BookstoreLayout from '../../components/@bookstore/bookstore-layout';
import { getAttributeValue } from '../../lib/attribute';
import Button from '../../components/button';
import useAddAllToCart from '../../hooks/use-add-all-to-cart';
import useProductsWhatsNew from '../../hooks/use-products-whats-new';

const OwnersWhatsNewPage: NextPage = () => {
  const { data, loading, error } = useProductsWhatsNew(
    process.env.SITE!,
    '' // leave empty to pull all item class besides SOFTWARE
  );

  const addToCart = useAddAllToCart({
    onCompleted: () => {
      window.location.href = '/cart';
    },
  });

  if (typeof window === 'undefined') {
    return null;
  }

  if (loading || error) {
    return null;
  }

  if (!data) {
    return null;
  }

  const onClick = (id) => {
    addToCart([
      {
        productId: id,
        quantity: 1,
        format: 'printed',
      },
    ]);
  };

  const fixedPrice = (price: string) => {
    let floatPrice = Number.parseFloat(price);

    if (isNaN(floatPrice)) {
      floatPrice = 0;
    }

    return floatPrice.toFixed(2);
  };

  return (
    <Layout title="New Owner's Literature">
      <BookstoreLayout
        title="What's New"
        breadcrumb={{ url: '/owners', text: 'Back' }}
        hero=""
      >
        <div className="product-grid">
          {data.productsWhatsNew.length === 0 && (
            <p>There have been no new items in the past 30 days.</p>
          )}
          {data.productsWhatsNew.map((product) => (
            <div className="product-item" key={product.id}>
              <h2>{product.name}</h2>
              <p>{product.sku}</p>
              <p>
                $
                {fixedPrice(getAttributeValue(product.attributes, 'itemprice'))}
              </p>
              {product.inventoryCount > 0 ? (
                <Button
                  text="Add to Cart"
                  onClick={() => onClick(product.id)}
                />
              ) : (
                <Button
                  text="Out of Stock"
                  disabled={true}
                  onClick={() => {}}
                />
              )}
            </div>
          ))}
        </div>
        {/* language=CSS */}
        <style jsx>{`
          .product-grid {
            margin-top: 2rem;
            display: flex;
            flex-wrap: wrap;
            gap: 1rem;
          }

          .product-item {
            flex: 1 0 32%;
            box-sizing: border-box;
          }

          .product-item h2 {
            font-family: 'Volvo Novum', sans-serif;
            font-weight: 500;
            font-size: 18px;
          }

          .product-item p {
            font-family: 'Volvo Novum', sans-serif;
            font-weight: 400;
            font-size: 14px;
          }

          p {
            font-family: 'Volvo Novum', sans-serif;
            font-weight: 400;
            font-size: 14px;
            padding: 0 2rem;
          }
        `}</style>
      </BookstoreLayout>
    </Layout>
  );
};

export default OwnersWhatsNewPage;
